export var Stage;
(function (Stage) {
    Stage["Staging"] = "Staging";
    Stage["Prod"] = "Prod";
})(Stage || (Stage = {}));
//# sourceMappingURL=Types.js.map